import { Injectable } from '@angular/core';
import { DEFAULT_TICKET_FILTERS_CONFIG } from '@shared/components/service-tickets/service-tickets.data';
import { TicketFilter } from '@shared/models/help-ticket.model';

@Injectable({
  providedIn: 'root',
})
export class TicketServiceService {
  cache$ = {};

  public getServiceTicketsFilters(): TicketFilter {
    const val = JSON.parse(localStorage.getItem('serviceTicketsFilters'));
    if (val) {
      return val as unknown as TicketFilter;
    } else {
      return DEFAULT_TICKET_FILTERS_CONFIG;
    }
  }

  public setServiceTicketsFilters(serviceTicketsFilters: TicketFilter) {
    localStorage.setItem('serviceTicketsFilters', JSON.stringify(serviceTicketsFilters as unknown as string));
  }

  public clearServiceTicketsFilters(): TicketFilter {
    localStorage.setItem('serviceTicketsFilters', JSON.stringify(DEFAULT_TICKET_FILTERS_CONFIG));
    return DEFAULT_TICKET_FILTERS_CONFIG;
  }
}
